export default __webpack_public_path__ + "release-module-empty-heading.png";